module.exports = __webpack_public_path__ + "img/exponentialekvation1.4e3e0cd5.jpg";